import { camelize } from 'humps';

import {
  GET_PAUSE_REASONS_REQUEST,
  GET_PAUSE_REASONS_RESPONSE,
  GET_PAUSE_REASONS_ERROR,
} from 'actions/account';

const initialState = {
  isLoading: false,
  isError: false,
  results: [],
  pauseReasons: [],
};

const transformPauseReasons = pauseReasons =>
  pauseReasons.map(reason => {
    return { ...reason, code: camelize(reason.code) };
  });

export default (state = initialState, action) => {
  const { type, response } = action;
  switch (type) {
    case GET_PAUSE_REASONS_REQUEST:
      return { ...state, isLoading: true, isError: false, pauseReasons: [] };
    case GET_PAUSE_REASONS_RESPONSE:
      return {
        ...state,
        isLoading: false,
        pauseReasons: transformPauseReasons(response.pauseReasons),
      };
    case GET_PAUSE_REASONS_ERROR:
      return { ...state, isLoading: false, isError: true, pauseReasons: [] };
    default:
      return state;
  }
};
